module.exports = __webpack_public_path__ + "files/b20ba075590f7dc33e389c11dc34645d.svg";